import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { getSeatPermissions } from "@components/table/members/assign-seats/assign-seats-utils";
import { useRefreshSeatUsage } from "@components/table/members/assign-seats/use-refresh-seat-usage";
import { setMemberPermissionsInCompany } from "@store/members/members-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
/** Returns how to give a member a SCENE seat or take it away again, and how to give a Sphere XG seat */
export function useSceneSeatPermission() {
  const $ = _c(12);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const refreshSeatUsage = useRefreshSeatUsage();
  let t0;
  if ($[0] !== companyId || $[1] !== dispatch) {
    t0 = async function setSeatPermissions(member, changes) {
      await dispatch(setMemberPermissionsInCompany({
        companyId,
        userIdentity: member.identity,
        permissions: getSeatPermissions(changes)
      })).unwrap();
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setSeatPermissions = t0;
  let t1;
  if ($[3] !== setSeatPermissions) {
    t1 = async function setSceneSeatPermission(member_0, isAllowed) {
      await setSeatPermissions(member_0, [{
        seat: "sceneSeat",
        isAssigning: isAllowed
      }]);
    };
    $[3] = setSeatPermissions;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const setSceneSeatPermission = t1;
  let t2;
  if ($[5] !== setSeatPermissions) {
    t2 = async function setXgSeatPermission(member_1) {
      await setSeatPermissions(member_1, [{
        seat: "xgSeat",
        isAssigning: true
      }]);
    };
    $[5] = setSeatPermissions;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const setXgSeatPermission = t2;
  let t3;
  if ($[7] !== refreshSeatUsage || $[8] !== setSceneSeatPermission || $[9] !== setSeatPermissions || $[10] !== setXgSeatPermission) {
    t3 = {
      setSeatPermissions,
      setSceneSeatPermission,
      setXgSeatPermission,
      refreshSeatUsage
    };
    $[7] = refreshSeatUsage;
    $[8] = setSceneSeatPermission;
    $[9] = setSeatPermissions;
    $[10] = setXgSeatPermission;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}